export default "__VITE_ASSET__Bg5y54Z3__"